/** */
import { urls } from '../_url';
import { apiGet } from '../_http';

/** */
const base_url = `${urls.mailometric}/reports`;

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readCampaignAverages = async (org_id, options = {}) => {
  return await apiGet(`${base_url}/campaign-averages/${org_id}`, { ...options });
};

export const readMonthly = async (options = {}) => {
  return await apiGet(`${urls.reports}/reports/monthly`, { ...options });
};
